import { useEffect, useMemo, useRef, useState } from "react";
import { Modal, Spinner } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { closeChangePasswordModal } from "../../../app/redux/features/changePassword/changePasswordSlice";
import { changePassword } from "../../../app/redux/features/changePassword/changePasswordActions";
import { Field, FormikProvider, useFormik } from "formik";
import * as Yup from 'yup';
import FieldInputText from "../../../app/modules/common/FieldInputText";
import SubmitButton from "../../../app/modules/common/SubmitButton";
import { MESSAGES } from "../../../app/utlis/messages";

const validationSchema = Yup.object({
  oldPassword: Yup.string()
    .required(MESSAGES.OLD_PASSWORD_REQUIRED)
    .min(8, MESSAGES.PASSWORD_SHOULD_8_CHARACTERS)
    .matches(/[A-Z]/, MESSAGES.ONE_UPPERCASE_LETTER_REQUIRED)
    .matches(/[a-z]/, MESSAGES.ONE_LOWERCASE_LETTER_REQUIRED)
    .matches(/[0-9]/, MESSAGES.ONE_NUMBER_REQUIRED)
    .matches(/[@#%!-]/, MESSAGES.ONE_SPECIAL_CHARACTER_REQUIRED),

  newPassword: Yup.string()
    .required(MESSAGES.NEW_PASSWORD_REQUIRED)
    .min(8, MESSAGES.PASSWORD_SHOULD_8_CHARACTERS)
    .matches(/[A-Z]/, MESSAGES.ONE_UPPERCASE_LETTER_REQUIRED)
    .matches(/[a-z]/, MESSAGES.ONE_LOWERCASE_LETTER_REQUIRED)
    .matches(/[0-9]/, MESSAGES.ONE_NUMBER_REQUIRED)
    .matches(/[@#%!-]/, MESSAGES.ONE_SPECIAL_CHARACTER_REQUIRED),

  confirmPassword: Yup.string()
    .required(MESSAGES.PLEASE_CONFIRM_PASSWORD)
    .oneOf([Yup.ref('newPassword')], MESSAGES.PASSWORD_MUST_MATCH),
});

const ChangePasswordModal = () => {
  const dispatch: any = useDispatch();
  const { openChangePasswordDetailModal, loading } = useSelector(
    (state: any) => state.changePasswordDetailsSlice
  );

  const [showOldPassword, setShowOldPassword] = useState(true);
  const [showNewPassword, setShowNewPassword] = useState(true);
  const [showConfirmPassword, setShowConfirmPassword] = useState(true);

  const initialValues = useMemo(() => ({
    oldPassword: '',
    newPassword: '',
    confirmPassword: '',
  }), []);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues,
    validationSchema,
    onSubmit: async (values) => {
      const { confirmPassword, ...payload } = values;
      console.log(values, "values")
      try {
        await dispatch(changePassword({ values: payload }));
        handleClose();
      } catch (error) {
        console.error("Error while changing the password:", error);
      }
    },
  });

  const prevOpenRef = useRef<boolean>(openChangePasswordDetailModal);
  useEffect(() => {
    if (prevOpenRef.current && !openChangePasswordDetailModal) {
      formik.resetForm();
    }
    prevOpenRef.current = openChangePasswordDetailModal;
  }, [openChangePasswordDetailModal]);

  const handleClose = () => {
    dispatch(closeChangePasswordModal());
  };

  return (
    <Modal show={openChangePasswordDetailModal} onHide={handleClose} centered size="sm">
      <Modal.Header closeButton className="bg-light text-black position-relative">
        <Modal.Title>{MESSAGES.CHANGE_PASSWORD}</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div className="text-gray-500 fw-semibold fs-6 mb-4">
          {MESSAGES.PASSWORD_COMBINATION}
        </div>

        {loading ? (
          <div className="d-flex justify-content-center py-5">
            <Spinner animation="border" variant="primary" />
          </div>
        ) : (
          <FormikProvider value={formik}>
            <form onSubmit={formik.handleSubmit} noValidate>
              <div className="row">

                <div className="fv-row mb-3 password-input-wrapper">
                  <div className="position-relative">
                    <Field
                      name="oldPassword"
                      label="Vecchia parola d'ordine"
                      type={showOldPassword ? 'password' : 'text'}
                      required
                      component={FieldInputText}
                      placeholder="Vecchia parola d'ordine"
                    />
                    <i
                      className={showOldPassword ? 'bi bi-eye-slash-fill eyeIcon' : 'bi bi-eye-fill eyeIcon'}
                      onClick={() => setShowOldPassword(!showOldPassword)}
                    ></i>
                  </div>
                </div>

                <div className="fv-row mb-3 password-input-wrapper">
                  <div className="position-relative">
                    <Field
                      name="newPassword"
                      label="Nuova parola d'ordine"
                      type={showNewPassword ? 'password' : 'text'}
                      required
                      component={FieldInputText}
                      placeholder="Nuova parola d'ordine"
                    />
                    <i
                      className={showNewPassword ? 'bi bi-eye-slash-fill eyeIcon' : 'bi bi-eye-fill eyeIcon'}
                      onClick={() => setShowNewPassword(!showNewPassword)}
                    ></i>
                  </div>
                </div>

                <div className="fv-row mb-3 password-input-wrapper">
                  <div className="position-relative">
                    <Field
                      name="confirmPassword"
                      label="Conferma Password"
                      type={showConfirmPassword ? 'password' : 'text'}
                      required
                      component={FieldInputText}
                      placeholder="Conferma Password"
                    />
                    <i
                      className={showConfirmPassword ? 'bi bi-eye-slash-fill eyeIcon' : 'bi bi-eye-fill eyeIcon'}
                      onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                    ></i>
                  </div>
                </div>
              </div>

              <div className="d-grid mt-3">
                <SubmitButton title={MESSAGES.SAVE_CHANGES} type="submit" loading={false} />
              </div>
            </form>
          </FormikProvider>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default ChangePasswordModal;
